import { Sort } from "../../UI-Components/Sort/sort";

export class SearchSubmittalModel {
    constructor(public projectId: string, public projectNumber: string, public projectName: string, public submittalType: string, public townId: number, public townName: string,
        public submittalDateRange: Date[], public mepaAnalyst: string, public status: number, public pageSize: number, public page: number, public sort: Sort) {
        }
}
